import {Routes} from '@angular/router';

import {AdminLayoutComponent} from './layouts/admin/admin-layout.component';
import {AuthLayoutComponent} from './layouts/auth/auth-layout.component';

import {AuthGuard} from './shared/services/auth.guard';
import {AdminGuard} from "./shared/services/admin.guard";

export const AppRoutes: Routes = [
    {
        path: '',
        component: AdminLayoutComponent,
        children: [
            // {
            //     path: '',
            //     redirectTo: 'dashboard',
            //     pathMatch: 'full',
            // },
            {
                path: '',
                loadChildren: './dashboard/dashboard.module#DashboardModule',
                canActivate: [AuthGuard]
            },
            {
                path: 'works',
                loadChildren: './works/works.module#WorksModule',
                canActivate: [AuthGuard]
            },
            {
                path: 'admin',
                loadChildren: './admin/admin.module#AdminModule',
                canActivate: [AdminGuard]
            },
            {
                path: 'patients',
                loadChildren: './patients/patients.module#PatientsModule',
                canActivate: [AuthGuard]
            },
            {
                path: 'profile',
                loadChildren: './profile/profile.module#ProfileModule',
                canActivate: [AuthGuard]
            },
            {
                path: 'external-doctors',
                loadChildren: './external-doctors/doctors.module#ExternalDoctorsModule',
                canActivate: [AuthGuard]
            },
            {
                path: 'external-companies',
                loadChildren: './external-companies/companies.module#ExternalCompaniesModule',
                canActivate: [AuthGuard]
            },
        ],
        //canActivate: [LockGuard]
    },
    {
        path: '',
        component: AuthLayoutComponent,
        children: [{
            path: 'session',
            loadChildren: './session/session.module#SessionModule',
        }]
    },
    {
        path: '**',
        redirectTo: 'session/404'
    }
];



// WEBPACK FOOTER //
// /Users/cricketmon/Sites/clubsandwichadmin/src/app/app.routing.ts